
// Ícones fiéis ao handoff (estilo outline)
import homeOutline from "@iconify/icons-eva/home-outline"
import personOutline from '@iconify/icons-eva/person-outline';
import layersOutline from '@iconify-icons/mdi/layers-outline';
import sparkle from '@iconify-icons/mdi/star-four-points-outline';
import flaskOutline from '@iconify-icons/mdi/flask-outline';
import clockOutline from '@iconify-icons/mdi/clock-outline';
import creditCardOutline from '@iconify-icons/mdi/credit-card-outline';
import accountOutline from '@iconify-icons/mdi/account-outline';
import playCircleOutline from '@iconify-icons/mdi/play-circle-outline';
import helpCircleOutline from '@iconify-icons/mdi/help-circle-outline';
import gridOutline from '@iconify-icons/mdi/view-grid-outline';
import waterOutline from '@iconify-icons/mdi/water-outline';
import cubeOutline from '@iconify-icons/mdi/cube-outline';
import pill from '@iconify-icons/mdi/pill';
import tagOutline from '@iconify-icons/mdi/tag-outline';
import molecule from '@iconify-icons/mdi/molecule';
import ticketOutline from '@iconify-icons/mdi/ticket-outline';
import toggleSwitchOutline from '@iconify-icons/mdi/toggle-switch-outline';
import CardGiftcardIcon from '@iconify/icons-eva/gift-outline';

import { getIcon } from "../../utils/IconUtil";
import { SidebarNavGroup } from "../../components/ui/SidebarNav";

// ----------------------------------------------------------------------

interface PlatformFlags {
  cleoEnabled: boolean;
  patientsEnabled: boolean;
}

/** Grupos da sidebar do app (ordem do handoff). Itens com flag desligada somem. */
export function getPlatformGroups({ cleoEnabled, patientsEnabled }: PlatformFlags): SidebarNavGroup[] {
  return [
    {
      label: "Principal",
      items: [
        { title: "Início", path: "/dashboard/app", icon: getIcon(homeOutline) },
        ...(cleoEnabled
          ? [{ title: "Cléo", path: "/dashboard/cleo", icon: getIcon(sparkle), badge: "IA" as const }]
          : []),
        { title: "Nova consulta", path: "/dashboard/query", icon: getIcon(flaskOutline) },
        { title: "Histórico", path: "/dashboard/history", icon: getIcon(clockOutline) },
        ...(patientsEnabled
          ? [{ title: "Pacientes", path: "/dashboard/patients", icon: getIcon(personOutline), badge: "NOVO" as const }]
          : []),
        { title: "Ativos", path: "/dashboard/actives", icon: getIcon(layersOutline) },
      ],
    },
    {
      label: "Conta",
      items: [
        { title: "Planos", path: "/dashboard/pricing", icon: getIcon(creditCardOutline) },
        { title: "Histórico de planos", path: "/dashboard/planHistory", icon: getIcon(clockOutline) },
        { title: "Meu perfil", path: "/dashboard/profile", icon: getIcon(accountOutline) },
        { title: "Tutoriais", path: "/dashboard/tutorial", icon: getIcon(playCircleOutline) },
        { title: "Suporte", path: "/dashboard/support", icon: getIcon(helpCircleOutline) },
      ],
    },
  ];
}

/** Grupos da sidebar em /adm/* — M5 handoff: 5 grupos */
export const adminGroups: SidebarNavGroup[] = [
  {
    label: "Visão geral",
    items: [
      { title: "Início", path: "/adm", icon: getIcon(gridOutline), exact: true },
    ],
  },
  {
    label: "Catálogo",
    items: [
      { title: "Ativos", path: "/adm/actives", icon: getIcon(waterOutline) },
      { title: "Produtos", path: "/adm/products", icon: getIcon(cubeOutline) },
      { title: "Produtos orais", path: "/adm/oral", icon: getIcon(pill) },
      { title: "Subclasses", path: "/adm/subclass", icon: getIcon(tagOutline) },
      { title: "DCO", path: "/adm/DCO", icon: getIcon(molecule) },
      { title: "Veículos", path: "/adm/vehicles", icon: getIcon(flaskOutline) },
    ],
  },
  {
    label: "Comercial",
    items: [
      { title: "Planos", path: "/adm/plans", icon: getIcon(creditCardOutline) },
      { title: "Cupons", path: "/adm/cupom", icon: getIcon(ticketOutline) },
      { title: "Brindes", path: "/adm/gifts", icon: getIcon(CardGiftcardIcon) },
    ],
  },
  {
    label: "Pessoas",
    items: [
      { title: "Usuários", path: "/adm/users", icon: getIcon(personOutline) },
    ],
  },
  {
    label: "Sistema",
    items: [
      { title: "Tutoriais", path: "/adm/tutorial", icon: getIcon(playCircleOutline) },
      { title: "Feature flags", path: "/adm/feature-flags", icon: getIcon(toggleSwitchOutline) },
      { title: "Experimentos de IA", path: "/adm/ai-experiments", icon: getIcon(sparkle) },
    ],
  },
];
